export const Services = {
  web: 'assets/services/web.png',
  mobile: 'assets/services/mobile.png',
  design: 'assets/services/design.png',
  'next-gen': 'assets/services/next-gen.png',
  mixed: 'assets/services/mixed.png',
}
